const jumpLinkFirst = document.querySelector( '.main__wrap > .jump-links .jump-links__wrap:first-child' );

if ( jumpLinkFirst ) {
	jumpLinkFirst.classList.add( 'jumplink-active' );
}
const jumpLink = Array.from(document.querySelectorAll( '.jump-links__wrap' ));

const handleClick = (e) => {
//   e.preventDefault();
  const active = document.querySelector('.jumplink-active');
  if(active){
    active.classList.remove('jumplink-active');
  }
  e.currentTarget.classList.add('jumplink-active');
}
jumpLink.forEach(node => {
  node.addEventListener('click', handleClick)
});
			